import { render, staticRenderFns } from "./WinningShares.vue?vue&type=template&id=592be9d7&scoped=true&"
import script from "./WinningShares.vue?vue&type=script&lang=js&"
export * from "./WinningShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592be9d7",
  null
  
)

export default component.exports